/**
 * Project : workspace
 * File    : OrderCard.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package component.order

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ExpandLess
import androidx.compose.material.icons.filled.ExpandMore
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.parmartechnologies.app.composeapp.generated.resources.Res
import com.parmartechnologies.app.composeapp.generated.resources.customer_app
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.business.feature.businessConfig.handler.BusinessConfigHandler
import com.parmartechnologies.commerce.feature.alert.handler.AlertHandler
import com.parmartechnologies.commerce.feature.order.viewModel.OrderViewModel
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.core.feature.order.model.Order
import com.parmartechnologies.core.feature.order.status.OrderStatus
import component.button.DefaultButton
import component.visual.DottedLine
import engine.date.DateEngine
import locale.localization
import navigation.AppNavigator
import org.jetbrains.compose.resources.painterResource
import theme.ThemeColor
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalTime::class)
@Composable
        /**
         * Executes the order card operation.
         *
         * @receiver TODO
         * @param Order The order.
         * @return Unit – no return value.
         */
fun OrderCard(
    business: Business,
    order: Order,
    viewModel: BusinessViewModel,
    onClick: (Order) -> Unit
) {
    val orderViewModel = remember { OrderViewModel(business) }
    var business by remember { mutableStateOf<Business?>(null) }
    var isExpanded by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        if (order.BusinessID.isNotEmpty()) {
            viewModel.getBusinessById(order.BusinessID) {
                business = it
            }
        }
    }

    Column(
        modifier = Modifier
            .heightIn(min = 190.dp) // use heightIn to allow expansion
            .padding(8.dp)
            .fillMaxWidth()
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(Color.White, shape = RoundedCornerShape(10.dp))
                .clip(RoundedCornerShape(10.dp))
                .padding(12.dp)
        ) {
            Column {
                // Business Header
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable { onClick(order) },
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Box(
                        modifier = Modifier
                            .size(60.dp)
                            .background(Color.White, shape = RoundedCornerShape(10.dp))
                            .clip(RoundedCornerShape(10.dp)),
                        contentAlignment = Alignment.Center
                    ) {
                        Image(
                            painter = painterResource(Res.drawable.customer_app),
                            contentDescription = "",
                            modifier = Modifier.height(42.dp).width(42.dp).padding(4.dp)
                        )
                    }
                    Spacer(modifier = Modifier.width(8.dp))
                    Column(
                        modifier = Modifier.weight(1f)
                    ) {
                        Text(
                            text = business?.Name ?: "",
                            fontSize = 16.sp,
                            fontWeight = FontWeight.SemiBold
                        )
//                        Text(
//                            text = AddressUtill().getAddressToDisplayInSingleLine(business?.Address),
//                            fontSize = 12.sp,
//                            color = Color.Gray
//                        )
                        Text(
                            text = DateEngine().displayableDateTime(order.updatedAt),
                            fontSize = 12.sp,
                            color = Color.Gray
                        )
                    }
                    Text(
                        text = order.status?.name ?: "",
                        fontSize = 12.sp,
                        color = ThemeColor.shared().PrimaryColor,
                        modifier = Modifier.padding(start = 8.dp)
                    )
                }

                Spacer(modifier = Modifier.height(6.dp))
                DottedLine()

                // Summary Row
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable { isExpanded = !isExpanded }
                        .background(
                            ThemeColor.shared().rowHeadingColor,
                            shape = RoundedCornerShape(6.dp)
                        )
                        .padding(8.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Text(
                        text = "${order.orderItems.count()} Item(s)",
                        modifier = Modifier.weight(2f),
                        fontWeight = FontWeight.Medium
                    )
                    Text(
                        text = "${
                            BusinessConfigHandler.shared().getCurrencySymbol(order.pricing.currency)
                        } ${order.pricing.FinalPrice}",
                        modifier = Modifier.padding(end = 8.dp),
                        fontWeight = FontWeight.Bold
                    )
                    Icon(
                        imageVector = if (isExpanded) Icons.Default.ExpandLess else Icons.Default.ExpandMore,
                        contentDescription = null,
                        tint = ThemeColor.shared().PrimaryColor
                    )
                }

                // Order Items
                if (isExpanded) {
                    Spacer(modifier = Modifier.height(4.dp))
                    LazyColumn(
                        modifier = Modifier
                            .fillMaxWidth()
                            .heightIn(max = 160.dp)
                            .background(ThemeColor.shared().defaultBakground)
                    ) {
                        items(order.orderItems.size) { index ->
                            val item = order.orderItems[index]
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(vertical = 4.dp, horizontal = 8.dp),
                                horizontalArrangement = Arrangement.SpaceBetween
                            ) {
                                Text(
                                    text = "${item.quantity} x ${item.product.Name}",
                                    fontSize = 13.sp,
                                    modifier = Modifier.weight(2f)
                                )
                                Text(
                                    text = "${
                                        BusinessConfigHandler.shared()
                                            .getCurrencySymbol(order.pricing.currency)
                                    } ${item.price?.FinalPrice}",
                                    fontSize = 13.sp,
                                    modifier = Modifier.align(Alignment.CenterVertically)
                                )
                            }
                        }
                    }
                }

                Spacer(modifier = Modifier.height(12.dp))

                // Action Buttons
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(bottom = 4.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
//                    SecondaryButton(title = "Rate", onClick = { /* Handle */ })

                    DefaultButton(
                        title = when (order.status) {
                            OrderStatus.COMPLETED -> "Reorder"
                            OrderStatus.SHIPPED -> "Received"
                            else -> order.status.toString()
                        },
                        onClick = {
                            when (order.status) {
                                OrderStatus.SHIPPED -> {
                                    orderViewModel.updateStatus(
                                        order,
                                        OrderStatus.COMPLETED
                                    ) { success ->
                                        if (success) AppNavigator.shared().goBack()
                                        else AlertHandler.shared().showAlert(
                                            localization().order.orderAlertTitle,
                                            localization().order.orderAlertMessage
                                        )
                                    }
                                }
                                // Add re-order / tracking logic
                                else -> {}
                            }
                        },
                        modifier = Modifier.height(36.dp)
                    )
                }
            }
        }
    }
}